// The API is served by the same Rails app that serves this bundle, so it is
// always same-origin — no host, no CORS, no VITE_API_URL.
export const SERVER_API_PREFIX = "/pizza_hub";
export const darkMode = true;
